import React from "react";
import { colors } from "../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../common-components";

const UserRegisterVehicleCard = ({ vehicle, onManageClick }) => {
  return (
    <div
      style={{
        height: 50,
        width: "100%",
        cursor: "pointer",
        // borderRadius: 10,
        marginTop: 5,
        position: "relative",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        backgroundColor: colors.white,
        // overflow: "hidden",
      }}
    >
      <div
        style={{
          flex: 0.15,
          color: "#000000",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ marginLeft: 10 }}>{vehicle.registerNumber}</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.15,
          color: "#000000",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ marginLeft: 10 }}>{vehicle.liscenseNumber}</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.2,
          color: "#000000",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ marginLeft: 0 }}>{vehicle.vinNumber}</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.2,
          color: "#000000",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ marginLeft: 0 }}>{vehicle.engineNumber}</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.1,
          color: "#000000",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ marginLeft: 0 }}>{vehicle.make}</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.1,
          color: "#000000",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ marginLeft: 0 }}>{vehicle.series}</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.1,
          color: "#000000",

          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"MANAGE"}
          borderRadius={8}
          backgroundColor={colors.greenLight}
          height={30}
          width={90}
          onClick={onManageClick}
        />
      </div>
    </div>
  );
};

export default UserRegisterVehicleCard;
